import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import domain from ".././../../../domain";
import { Row, Col, Card, CardBody } from "mdbreact";
export default class EditCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course_id: "",
      cat_id: "",
      year: "",
      start_date: "",
      end_date: "",
      title: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };

  componentDidMount() {
    this.getCourseDetails();
  }

  getCourseDetails() {
    console.log(this.props);
    let courseId = this.props.match.params.id;
    console.log(courseId);
    axios
      .get(`${domain.DBServer}/fetch-course/${courseId}`)
      .then((course) => {
        console.log(course.data);

        this.setState({
          course_id: course.data[0].course_id,
          cat_id: course.data[0].cat_id,
          start_date: course.data[0].start_date,
          end_date: course.data[0].end_date,
          title: course.data[0].title,
          year: course.data[0].year,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  editcourse(newcourse) {
    console.log(newcourse);
    let courseId = this.props.match.params.id;
    axios
      .request({
        method: "PUT",
        url: `${domain.DBServer}/edit-course/${courseId}`,
        data: newcourse,
      })
      .then((response) => {
        if (response.data === 1) {
          alert("Details are updated Successfully");
          this.props.history.push(`/view-courses/${courseId}`);
        } else {
          alert("Details are not updated");
        }
      })
      .catch((err) => console.log(err));
  }

  onSubmit(e) {
    e.preventDefault();

    const newcourse = {
      course_id: this.state.course_id,
      cat_id: this.state.cat_id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      title: this.state.title,
      year: this.state.year,
    };
    let r = window.confirm("Please check once again before submission");

    if (r) {
      this.editcourse(newcourse);
    } else {
      return false;
    }
  }

  render() {
    let y, day, m, d, finaldate, y1, day1, m1, d1, finaldate1;
    d = new Date(this.state.start_date);
    day = ("0" + d.getDate()).slice(-2);
    m = ("0" + (d.getMonth() + 1)).slice(-2);
    y = d.getFullYear();
    finaldate = y + "-" + m + "-" + day;
    console.log("final date" + finaldate);
    d1 = new Date(this.state.end_date);
    day1 = ("0" + d1.getDate()).slice(-2);
    m1 = ("0" + (d1.getMonth() + 1)).slice(-2);
    y1 = d1.getFullYear();
    finaldate1 = y1 + "-" + m1 + "-" + day1;
    return (
      <div>
        <br />
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                <Link className="btn grey" to="/view-courses">
                  Back
                </Link>
                <form onSubmit={this.onSubmit.bind(this)}>
                  <div className="form-group-sm row">
                    <label className="mr-sm-2">Year</label>
                    <select
                      className="custom-select mr-sm-2"
                      ref={this.yearRef}
                      required
                      name="year"
                      onChange={this.handleInputChange}
                    >
                      <option selected>Choose...</option>
                      <option
                        value="2017-18"
                        selected={this.state.year === "2017-18"}
                      >
                        2017-18
                      </option>
                      <option
                        value="2018-19"
                        selected={this.state.year === "2018-19"}
                      >
                        2018-19
                      </option>
                      <option
                        value="2019-20"
                        selected={this.state.year === "2019-20"}
                      >
                        2019-20
                      </option>
                      <option
                        value="2010-21"
                        selected={this.state.year === "2020-21"}
                      >
                        2020-21
                      </option>
                      <option
                        value="2021-22"
                        selected={this.state.year === "2021-22"}
                      >
                        2021-22
                      </option>
                      <option
                        value="2022-23"
                        selected={this.state.year === "2022-23"}
                      >
                        2022-23
                      </option>
                      <option
                        value="2023-24"
                        selected={this.state.year === "2023-24"}
                      >
                        2023-24
                      </option>
                    </select>
                  </div>
                  <div className="form-group-sm row">
                    <label className="mr-sm-2">Course Category</label>
                    <select
                      className="custom-select mr-sm-2"
                      name="cat_id"
                      onChange={this.handleInputChange}
                    >
                      <option selected>Choose...</option>
                      <option value="1" selected={this.state.cat_id === "1"}>
                        One-Week
                      </option>
                      <option value="2" selected={this.state.cat_id === "2"}>
                        Two-week
                      </option>
                      <option value="3" selected={this.state.cat_id === "3"}>
                        Customized
                      </option>
                    </select>
                  </div>

                  <div className="form-group-sm row">
                    <label
                      className="col-sm-2 col-form-label col-form-label-sm"
                      for="validationTooltip01"
                    >
                      Course Title
                    </label>
                    <input
                      className="form-control"
                      value={this.state.title}
                      type="text"
                      id="validationTooltip01"
                      ref={this.courseTitleRef}
                      placeholder="Title of the course"
                      required
                      name="title"
                      onChange={this.handleInputChange}
                    />
                    <div className="valid-tooltip">Looks good!</div>
                  </div>
                  <div className="form-group-sm row">
                    <label className="col-sm-2 col-form-label col-form-label-sm">
                      Course ID
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={this.state.course_id}
                      ref={this.courseIDRef}
                      placeholder="Course Id"
                      required
                      name="course_id"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="form-group-sm row">
                    <label className="col-sm-2 col-form-label col-form-label-sm">
                      Start Date
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      value={finaldate}
                      ref={this.startDateRef}
                      placeholder="Start Date"
                      required
                      name="start_date"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="form-group-sm row">
                    <label className="col-sm-2 col-form-label col-form-label-sm">
                      End Date
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      ref={this.endDateRef}
                      value={finaldate1}
                      placeholder="End Date"
                      required
                      name="end_date"
                      onChange={this.handleInputChange}
                    />
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
